import { enhancedApi } from '@store/generated/eprescriptions';

/**
 * Unified medication history (GDN-2351 Component D) — the first consumer of
 * GET /v2/provider/patients/{id}/medications/unified-history, now on the
 * codegen endpoint (the hand-written interim endpoint is gone; the types it
 * mirrored live on as re-exports in vm/unifiedApiTypes.ts).
 *
 * Cache coherence: the medication CRUD mutations in features/patients/store/api.ts
 * invalidate the `UnifiedMedications` tag so this view refreshes after writes.
 */
export const medicationsWorkspaceApi = enhancedApi.enhanceEndpoints({
  addTagTypes: ['UnifiedMedications'],
  endpoints: {
    getV2ProviderPatientsByPatientIdMedicationsUnifiedHistory: {
      providesTags: (_result, _error, { patientId }) => [
        { type: 'UnifiedMedications' as const, id: patientId },
      ],
    },
  },
});

export const {
  useGetV2ProviderPatientsByPatientIdMedicationsUnifiedHistoryQuery:
    useUnifiedMedicationsQuery,
} = medicationsWorkspaceApi;
